<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-sales-hold',
    }"
  >
    <h4 class="mt-6 mb-9">
      Let's connect, {{ firstName }}!
    </h4>
    <p class="p3 mb-6">
      We want you to have the best possible Datapeople experience.
      So {{ accountExecutiveName || 'someone' }} from our New Accounts team has
      reached out to you to learn more about {{ companyName || 'your company' }}
      and help you get started. Check your email soon – we can't wait to meet you!
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'SalesHold',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, [
      'firstName',
      'companyName',
      'accountExecutiveName',
      'accountExecutiveEmail',
    ]),
  },
  created() {
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-873652164/WA_vCPa7_tMBEMS_y6AD' });
    }
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Account on Hold' });
  },
};
</script>
